export const MIN_PASSWORD_LENGTH = 6;
export const MAX_PASSWORD_LENGTH = 128;

export interface ValidationResult {
  ok: boolean;
  messageKey?: string; // i18n 키
  message?: string;    // fallback 한국어
}

export function validatePassword(password: string): ValidationResult {
  if (!password) return { ok: false, messageKey: 'auth.passwordRequired', message: '비밀번호를 입력해 주세요.' };
  if (password.length < MIN_PASSWORD_LENGTH) {
    return { ok: false, messageKey: 'auth.passwordTooShort', message: `비밀번호는 ${MIN_PASSWORD_LENGTH}자 이상이어야 합니다.` };
  }
  if (password.length > MAX_PASSWORD_LENGTH) {
    return { ok: false, messageKey: 'auth.passwordTooLong', message: `비밀번호는 ${MAX_PASSWORD_LENGTH}자 이하여야 합니다.` };
  }
  return { ok: true };
}

export function validatePasswordConfirm(password: string, confirm: string): ValidationResult {
  if (password !== confirm) {
    return { ok: false, messageKey: 'auth.passwordMismatch', message: '비밀번호가 일치하지 않습니다.' };
  }
  return { ok: true };
}

export function showApiError(err: unknown, fallback: string): string {
  const e = err as { response?: { data?: { message?: string } }; message?: string };
  return e?.response?.data?.message ?? e?.message ?? fallback;
}
